import React, { useEffect } from 'react';
import { Formik, Form } from 'formik';
import { TextArea, TextInput } from '../../components/Form/Form';
import * as Yup from 'yup';
import axios from 'axios';
import { Link } from 'react-router-dom';
function Footer() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <div className='section section-padding-02'>
        <div className='container'>
          {/* Brand Start */}
          <div className='brand-wrapper brand-active'>
            <div className='swiper-container'>
              <div className='swiper-wrapper'>
                {/* Single Brand Start */}
                {/* <div class="swiper-slide single-brand">
    <img
      src="assets/images/brand/brand-1.webp"
      height="107"
      alt="Brand"
    />
  </div> */}
                {/* Single Brand End */}
                {/* Single Brand Start */}
                {/* <div class="swiper-slide single-brand">
    <img
      src="assets/images/brand/brand-2.webp"
      height="107"
      alt="Brand"
    />
  </div> */}
                {/* Single Brand End */}
                {/* Single Brand Start */}
                {/* <div class="swiper-slide single-brand">
    <img
      src="assets/images/brand/brand-3.webp"
      height="107"
      alt="Brand"
    />
  </div> */}
                {/* Single Brand End */}
                {/* Single Brand Start */}
                {/* <div class="swiper-slide single-brand">
    <img
      src="assets/images/brand/brand-4.webp"
      height="107"
      alt="Brand"
    />
  </div> */}
                {/* Single Brand End */}
                {/* Single Brand Start */}
                {/* <div class="swiper-slide single-brand">
    <img
      src="assets/images/brand/brand-5.webp"
      height="107"
      alt="Brand"
    />
  </div> */}
                {/* Single Brand End */}
              </div>
            </div>
          </div>
          {/* Brand End */}
        </div>
      </div>
      <div className='footer-section section'>
        {/* Footer Top Start */}
        <div className='footer-top'>
          <img
            className='shape-1 movebounce-01'
            src='/assets/images/shape/shape-16.webp'
            width={185}
            height={231}
            alt='Shape'
          />
          <img
            className='shape-2 movebounce-02'
            src='/assets/images/shape/shape-17.webp'
            width={188}
            height={156}
            alt='Shape'
          />
          <img
            className='shape-3 movebounce-01'
            src='/assets/images/shape/shape-18.webp'
            width={503}
            height={287}
            alt='Shape'
          />
          <div className='container'>
            {/* Newsletter Wrapper Start */}
            <div
              className='newsletter-wrapper text-center'
              data-aos='fade-up'
              data-aos-delay={200}
            >
              <a className='logo' href='#'>
                <img
                  src='/assets/images/logo.png'
                  width={172}
                  height={45}
                  alt='Logo'
                />
              </a>
              <h4 className='title'>SUBSCRIBE &amp; ENJOY</h4>
              <p>
                Get the latest updates &amp; offers by subscribing to our
                newsletter!
              </p>
              <div className='newsletter-form'>
                <form action='#'>
                  <input type='text' placeholder='Enter your email here' />
                  <button className='btn btn-white btn-hover-dark'>Send</button>
                </form>
              </div>
            </div>
            {/* Newsletter Wrapper End */}
            {/* Footer Widget Wrapper Start */}
            <div className='footer-widget-wrapper'>
              <div className='row'>
                <div className='col-lg-3 col-sm-6'>
                  {/* Footer Widgte Start */}
                  <div
                    className='footer-widget'
                    data-aos='fade-up'
                    data-aos-delay={150}
                  >
                    <h4 className='widget-title'>Contact Info</h4>
                    {/* Widgte Info Start */}
                    <div className='footer-widget-info'>
                      <div className='single-widget-info'>
                        <h6 className='title'>Galleria Branch Address :</h6>
                        <p>
                          4306, Ground Floor, DLF Phase 4, <br />
                          Adjacent to Galleria market, Gurgaon, Haryana - 122009
                        </p>
                        {/* <p>
                          <strong>Landline </strong>
                          <a href='tel:+02154785654'>+02154 785 654</a>
                        </p> */}
                        <p>
                          <strong>Mobile </strong>
                          <a href='tel:+8826815442'>8826815442</a>
                        </p>
                      </div>
                      {/* <div className='single-widget-info'>
                        <h6 className='title'>Sector 45 Branch Address :</h6>
                        <p>
                          Plot no. 42, Ground Floor, Sector 45,
                          <br />
                          Near Hotel Palm Bliss, Gurgaon, Haryana - 122003
                        </p>
                        <p>
                          <strong>Landline </strong>
                          <a href='tel:+01244277794'>01244277794</a>
                        </p>
                        <p>
                          <strong>Mobile </strong>
                          <a href='tel:+9810447794'>9810447794 </a>
                        </p>
                      </div> */}
                      {/* <div class="single-widget-info">
          <h6 class="title">Phone</h6>
          <p><a href="tel:+02154785654">+02154 785 654</a></p>
          <p><a href="tel:+98745852147">+98745 852 147</a></p>
        </div> */}
                    </div>
                    {/* Widgte Info End */}
                  </div>
                  {/* Footer Widget End */}
                </div>
                <div className='col-lg-3 col-sm-6'>
                  {/* Footer Widgte Start */}
                  <div
                    className='footer-widget'
                    data-aos='fade-up'
                    data-aos-delay={300}
                  >
                    <h4 className='widget-title'>Quick Link</h4>
                    {/* Widgte Link Start */}
                    <div className='footer-widget-link'>
                      <ul>
                        <li>
                          <Link to='/about-us'>About us</Link>
                        </li>
                        <li>
                          <Link to='/contact-us'>Contact us</Link>
                        </li>
                        <li>
                          <Link to='/blogs'>Blogs</Link>
                        </li>
                        <li>
                          <Link to='/our-services/skin-rejuvenation'>
                            Skin Rejuvenation
                          </Link>
                        </li>
                        <li>
                          <Link to='/our-services/vampire-facial'>
                            Vampire Facial
                          </Link>
                        </li>
                        <li>
                          <Link to='/our-services/hydra-facial'>
                            HydraFacial
                          </Link>
                        </li>
                        <li>
                          <Link to='/our-services/chemical-peels'>
                            Chemical Peel
                          </Link>
                        </li>
                        <li>
                          <Link to='/our-services/photofacial'>
                            Photofacial
                          </Link>
                        </li>
                        <li>
                          <Link to='/our-services/anti-acne-treatment'>
                            Anti-Acne Treatment
                          </Link>
                        </li>
                        <li>
                          <Link to='/our-services/mesotherapy'>
                            Mesotherapy
                          </Link>
                        </li>
                      </ul>
                    </div>
                    {/* Widgte Link End */}
                  </div>
                  {/* Footer Widgte End */}
                </div>
                <div className='col-lg-3 col-sm-6'>
                  {/* Footer Widgte Start */}
                  <div
                    className='footer-widget'
                    data-aos='fade-up'
                    data-aos-delay={450}
                  >
                    <h4 className='widget-title'>Information</h4>
                    {/* Widgte Link Start */}
                    <div className='footer-widget-link'>
                      <ul>
                        <li>
                          <Link to='/our-services/hairfall-treatment'>
                            Hair Fall Treatment
                          </Link>
                        </li>
                        <li>
                          <Link to='/our-services/hair-prp-therapy'>
                            Hair PRP Therapy
                          </Link>
                        </li>
                        <li>
                          <Link to='/our-services/ayurvedic-treatment'>
                            Ayurvedic Treatments
                          </Link>
                        </li>
                        <li>
                          <Link to='/our-services/slimming-inch-loss-treatment'>
                            Slimming & Inch Loss
                          </Link>
                        </li>
                        <li>
                          <Link to='/our-services/cryolipolysis'>
                            Cryolipolysis
                          </Link>
                        </li>
                        <li>
                          <Link to='/our-services/pigmentation-removal'>
                            Pigmentation Removal
                          </Link>
                        </li>
                        <li>
                          <Link to='/our-services/laser-hair-reduction'>
                            Laser Hair Reduction
                          </Link>
                        </li>
                        {/* <li>
                          <Link to="/contact-us">Contact Us</Link>
                        </li>
                        <li>
                          <Link to="#">Terms &amp; Conditions</Link>
                        </li>
                        <li>
                          <Link to="#">Privacy Policy</Link>
                        </li>
                        <li>
                          <Link to="#">Refund Policy</Link>
                        </li> */}
                      </ul>
                    </div>
                    {/* Widgte Link End */}
                  </div>
                  {/* Footer Widgte End */}
                </div>
                <div className='col-lg-3 col-sm-6'>
                  {/* Footer Widgte Start */}
                  <div
                    className='footer-widget'
                    data-aos='fade-up'
                    data-aos-delay={600}
                  >
                    <h4 className='widget-title'>Opening Hour</h4>
                    {/* Widgte Info Start */}
                    <div className='footer-widget-info'>
                      <div className='single-widget-info'>
                        <h6 className='title'>Tuesday to Sunday</h6>
                        <p>10.00 am - 07.00 Pm</p>
                      </div>
                      <div className='single-widget-info'>
                        <h6 className='title'>Monday </h6>
                        <p>Closed</p>
                      </div>
                      <div className='single-widget-info'>
                        <h6 className='title'>Web</h6>
                        <p>
                          <a href='mailto:swakaayawellness@gmail.comm'>
                            swakaayawellness@gmail.com
                          </a>
                        </p>
                      </div>
                    </div>
                    {/* Widgte Info End */}
                    {/* Widgte Book End */}
                    <div className='footer-widget-book'>
                      <h5 className='book-title'>Book Now!</h5>
                      <p>
                        <i className='fa fa-phone'></i>
                        <a href='tel:8826815442'>+91-88268 15442</a>
                      </p>
                    </div>
                    <div className='single-info'>
                      <ul className='social'>
                        <li>
                          <a href='tel:88268 154422'>
                            <i className='fa fa-whatsapp' />
                          </a>
                        </li>
                        <li>
                          <a href='https://www.facebook.com/swakaaya'>
                            <i className='fa fa-facebook-f' />
                          </a>
                        </li>

                        <li>
                          <a href='https://www.instagram.com/swakaaya.wellness'>
                            <i className='fa fa-instagram' />
                          </a>
                        </li>
                      </ul>
                    </div>

                    {/* Widgte Book End */}
                  </div>
                  {/* Footer Widgte End */}
                </div>
              </div>
            </div>
            {/* Footer Widget Wrapper End */}
          </div>
        </div>
        {/* Footer Top End */}
        {/* Footer Copyright Start */}
        <div className='footer-copyright'>
          <div className='container'>
            {/* Copyright Wrapper Start */}
            <div className='copyright-wrapper flex-row-reverse'>
              <div className='payment-method'>
                <ul className='payment-icon'>
                  <li>
                    <img
                      src='/assets/images/payment-icon/icon-1.webp'
                      height={15}
                      alt='Icon'
                    />
                  </li>
                  <li>
                    <img
                      src='/assets/images/payment-icon/icon-2.webp'
                      height={15}
                      alt='Icon'
                    />
                  </li>
                  <li>
                    <img
                      src='/assets/images/payment-icon/icon-3.webp'
                      height={15}
                      alt='Icon'
                    />
                  </li>
                  <li>
                    <img
                      src='/assets/images/payment-icon/icon-4.webp'
                      height={15}
                      alt='Icon'
                    />
                  </li>
                </ul>
              </div>

              <div className='copyright-text'>
                <p>Copyright © 2022 - Swakaaya. All Rights Reserved.</p>
              </div>
            </div>
            {/* Copyright Wrapper End */}
          </div>
        </div>
        {/* Footer Copyright End */}
      </div>
      <button id='backBtn' className='back-to-top'>
        <i className='icofont-simple-up' />
      </button>
      <a
        href='https://wa.me/918826815442'
        target='_blank'
        rel='noopener noreferrer'
        style={{
          position: 'fixed',
          bottom: '80px',
          right: '20px',
          zIndex: 1000,
          backgroundColor: '#25D366',
          borderRadius: '50%',
          padding: '12px',
          boxShadow: '0 4px 6px rgba(0,0,0,0.2)',
          transition: 'transform 0.2s ease-in-out',
          cursor: 'pointer',
        }}
      >
        {/* WhatsApp SVG */}
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='25'
          height='25'
          fill='white'
          viewBox='0 0 24 24'
        >
          <path d='M20.52 3.48A11.91 11.91 0 0012.06 0C5.7 0 .48 5.22.48 11.58c0 2.04.54 4.03 1.58 5.78L0 24l6.84-2c1.67.92 3.55 1.41 5.47 1.41h.01c6.36 0 11.58-5.22 11.58-11.58 0-3.1-1.21-6.01-3.38-8.16zM12.32 21.5h-.01c-1.69 0-3.34-.45-4.78-1.3l-.34-.2-4.06 1.18 1.21-3.95-.22-.36a9.56 9.56 0 01-1.46-5.17c0-5.28 4.29-9.57 9.58-9.57 2.56 0 4.96.99 6.77 2.8 1.81 1.81 2.8 4.21 2.8 6.77 0 5.28-4.29 9.58-9.58 9.58zm5.23-7.15c-.29-.15-1.72-.85-1.98-.95-.27-.1-.46-.15-.66.15-.19.29-.76.95-.93 1.14-.17.19-.34.22-.63.07-.29-.15-1.23-.45-2.34-1.42-.86-.77-1.42-1.72-1.59-2.01-.16-.29-.02-.45.12-.6.12-.12.29-.34.44-.51.15-.17.19-.29.29-.48.1-.19.05-.36-.02-.51-.07-.15-.66-1.6-.91-2.19-.24-.58-.49-.5-.66-.51h-.56c-.19 0-.5.07-.76.36s-1 1-1 2.44 1.02 2.83 1.16 3.03c.15.19 2 3.06 4.85 4.29.68.29 1.21.46 1.62.59.68.22 1.29.19 1.77.12.54-.08 1.72-.7 1.96-1.37.24-.67.24-1.24.17-1.36-.07-.12-.27-.19-.56-.34z' />
        </svg>
      </a>

      {/*Back To End*/}
      {/* popup */}
      <div>
        <div
          className='modal fade'
          id='staticBackdrop'
          data-bs-backdrop='static'
          data-bs-keyboard='false'
          tabIndex={-1}
          aria-labelledby='staticBackdropLabel'
          aria-hidden='true'
        >
          <div className='modal-dialog'>
            <div className='modal-content'>
              <div className='modal-header'>
                <h3 class='title'>
                  Request a <span>Call Back</span>
                </h3>
                <button
                  type='button'
                  className='btn-close'
                  data-bs-dismiss='modal'
                  aria-label='Close'
                />
              </div>
              <div className='modal-body'>
                <div class='register-login-form'>
                  <div className='form-wrapper'>
                    <Formik
                      initialValues={{
                        name: '',
                        email: '',
                        phone: '',
                        message: '',
                      }}
                      validationSchema={Yup.object({
                        name: Yup.string().required('Required'),
                        email: Yup.string().required('Required'),
                        phone: Yup.string().required('Required'),
                      })}
                      onSubmit={async (
                        values,
                        { setSubmitting, resetForm }
                      ) => {
                        setSubmitting(true);
                        await axios.get(
                          `https://swakaaya.luhaifdigitech.com/mail.php?name=${values.name}&email=${values.email}&phone=${values.phone}&message=${values.message}`
                        );
                        resetForm();
                        setSubmitting(false);
                      }}
                    >
                      {(formik) => {
                        console.log(formik);
                        return (
                          <Form>
                            <div className='single-form'>
                              <TextInput
                                name='name'
                                placeholder='Name'
                                type='text'
                              />
                            </div>
                            <div className='single-form'>
                              <TextInput
                                name='email'
                                placeholder='Email'
                                type='email'
                              />
                            </div>
                            <div className='single-form'>
                              <TextInput
                                name='phone'
                                placeholder='Phone'
                                type='text'
                              />
                            </div>
                            <div className='single-form'>
                              <TextArea
                                name='message'
                                type='text'
                                rows='1'
                                cols='100'
                                placeholder='Message'
                              />
                            </div>
                            <div className='single-form'>
                              <button
                                type='submit'
                                className='btn btn-primary btn-hover-dark w-100'
                              >
                                BOOK AN APPOINTMENT
                              </button>
                            </div>
                          </Form>
                        );
                      }}
                    </Formik>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
